﻿$.fn.dxCtrlSondageQuestionText = function custom_dxCtrlSondageQuestionText(option) {
    if (option == "instance") {
        return this.instance;
    }
    else {
        this.addClass("dx-dxctrlsondagequestiontext dx-ctrl");
        this.createInstance(new cdxCtrlSondageQuestionText(this, option));
    }
    return this;
}

window.cdxCtrlSondageQuestionText = function (container, option) {
    var Me = this;


    this.option = function (name, value) {
        if (typeof value == 'undefined') {
            return option[name];
        }
        else {
            option[name] = value;
        }
    }

    function mConstruit() {
        container.empty()

        if (option.dataQuestion.id_page==-1) {
            if (typeof option.dataQuestion.tx_satisfaction_min == 'undefined') option.dataQuestion.tx_satisfaction_min = 0
            if (typeof option.dataQuestion.tx_satisfaction_max == 'undefined') option.dataQuestion.tx_satisfaction_max = 100
            var $Table = $("<table style='width:100%;margin-top:20px;'/>").appendTo(container)
            var $Tr = $("<tr/>").appendTo($Table)
            var $Td = $("<td style='width:100%;' colspan='2'/>").appendTo($Tr)
            $("<div style='margin-top:8px;'>Indiquez le taux de satisfaction minimum et maximum requis pour afficher ce texte. Le taux est calculé à partir de l'ensemble des réponses aux questions du sondage. Si le taux obtenu est inférieur au minimum ou supérieur au maximum, le texte ne sera pas affiché.</div>").appendTo($Td)
            $("<div/>").appendTo($Td).dxRangeSlider({
                min: 0,
                max: 100,
                start: option.dataQuestion.tx_satisfaction_min,
                end: option.dataQuestion.tx_satisfaction_max,
                step: 1,
                tooltip: {
                    enabled: true,
                    format(value) {
                        return `${value}%`;
                    },
                    showMode: 'always',
                    position: 'bottom',
                },
                onValueChanged: function (e) {
                    option.dataQuestion.tx_satisfaction_min = e.start
                    option.dataQuestion.tx_satisfaction_max = e.end
                    option.sondage.mSave()
                    if (option.onValueChanged) option.onValueChanged()
                }
            });
        }


        //$("<div style='font-size:140%;'/>").appendTo(container).html("Le texte saisie est un texte d'explication")
        $("<div style='font-style:italic;font-size:80%;'/>").appendTo(container).html("Cette question ne réclame pas d'interaction avec le répondeur.<br/>Elle permet juste d'intégrer un texte explicatif.")

        $("<div style='margin-top:20px;'/>").appendTo(container).dxCtrlHtmlEditorSimple({
            labelMode: "floating",
            label: "Texte d'explication",
            value: option.dataQuestion.text_intro,
            onValueChanged: function (e) {
                debugger;
                option.dataQuestion.text_intro = (e.value == null ? "" : e.value)
                option.sondage.mSave()
                if (option.onValueChanged) option.onValueChanged()
            }
        })
    }

    this.element = function () { return container }

    mConstruit();
}